export const SCRAPING_EVENT = 'SCRAPING_EVENT'
export const SCRAPING_ERROR = 'SCRAPING_ERROR'
